/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
-----------------------------------------------------------------------------*/

<template>
  <div class="flex-container">
    <div class="sr-only">
      <span>Use the select box to select a user</span>
      <label for="screenReaderSelectGroupUser">
        Selected User:
      </label>
      <select
        id="screenReaderSelectGroupUser"
        v-model="screenGroupUsers"
        multiple
        @change="screenReader"
      >
        <option
          v-for="option in options"
          :value="option.id"
        >
          {{ option.name }}
        </option>
      </select>
    </div>
    <div
      class="group-user-select-container"
      aria-hidden="true"
    >
      <div class="group-user-select">
        <vue-select
          v-model="selected"
          :multiple="multiple"
          :options="options"
          :searchable="!isSmallViewport"
          label="name"
          :reduce="option => option.id"
          :placeholder="(mode == 'group') ? 'select a group' : (mode == 'user') ? 'select a user' : 'select users or a group'"
          @input="loadGroupUser"
        >
          <template
            slot="option"
            slot-scope="option"
          >
            <div>
              <div style="display: inline-block; width: 20px; vertical-align: top; padding-top: 4px; margin-left: -10px;">
                <svg
                  v-if="option.type === 'group'"
                  class="icon-users"
                >
                  <use xlink:href="/static/svg-symbols.svg#icon-users" />
                </svg>
                <svg
                  v-else
                  class="icon-user"
                >
                  <use xlink:href="/static/svg-symbols.svg#icon-user" />
                </svg>
              </div>
              <div style="display: inline-block; padding-left: 4px;">
                <strong>{{ option.name }}</strong>
              </div>
            </div>
          </template>
        </vue-select>
      </div>
    </div>
  </div>
</template>

<style lang="less">
  .v-select .open-indicator:before,
  ul.dropdown-menu {
    border-color: #333 !important;
    border-radius: 0px !important;
  }
  .v-select .dropdown-toggle {
    border-radius: 8px !important;
  }
  .validSelections .v-select .dropdown-toggle {
    border-color: #333 !important;
  }
  .invalidSelections .v-select .dropdown-toggle {
    border-color: red !important;
  }
  .v-select.open .dropdown-toggle {
    border-bottom-color: #fff !important;
  }
  .v-select input[type=search] {
    width: 0px !important;
  }
  .open input[type=search] {
    width: auto !important;
  }
  .v-select.dropdown .highlight a,
  .v-select.dropdown li:hover a {
    //background: #eee !important;
  }

  .coachMode div.dropdown-toggle {
    span.selected-tag {
      color: #333;
    }
  }

  div.dropdown-toggle {
    span.selected-tag {
      font-size: 14px;
      font-weight: 400;
    }
    button.clear {
      span {
        display:none !important;
      }
      display:none !important;
    }
  }
  .flex-container {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: stretch;
  }
  .group-user-select-container {
    flex-grow: 8;
    margin-left: 5px;
  }
  .group-user-select-label {
    text-align: left;
    padding: 3px 0 0 0 !important;
  }
  @media (max-width: 991px) {
    .flex-container {
      display: block !important;
    }
  }
  .group-user-select-label {
    font-size: 16pt;
    color: #333;
    text-align: left;
    padding: 0 0 0 17px;
  }
  .group-user-select, .v-select {
    margin: 0 0 12px 0;
    max-width: 500px;
  }
  .icon-user, .icon-users {
    height: 16px; width: 16px;
    position: relative;
    bottom: 2px;
  }
</style>

<script>
import VueSelect from 'vue-select';
import util from '../utils/util';

export default {
  components: {VueSelect: VueSelect},
  props: ['groups', 'users', 'mode', 'multiple'],
  data() {
    return {
      selected: null,
      screenGroupUsers: [],
    };
  },
  computed: {
    options: {
      'cache': false,
      get() {
        let groupNames = {};
        let options = [];

        _.map(this.groups, (g) => {
          groupNames[g.groupId] = g.name;
          if (this.mode !== 'user') {
            options.push({
              type: 'group',
              name: 'Group: ' + g.name,
              id: g.groupId,
              groupId: g.groupId,
            });
          }
        });

        if (this.mode === 'userAndGroup' || this.mode === 'user') {
          _.map(this.users, (group, groupId) => {
            _.map(group, (user) => {
              const groupName = groupNames[groupId];
              if (!groupName) return;

              options.push({
                type: 'user',
                name: user.name + ' (' + groupName + ')',
                id: user.userId,
                groupId: groupId,
              });
            });
          });
        }
        return options;
      }
    },
    isSmallViewport: {
      cache: false,
      get: util.isSmallViewport
    },
  },
  created() {
    //this.screenGroupUser = this.group-user;
    window.setTimeout(() => {
      const tag = document.querySelector('div.dropdown-toggle span.selected-tag');
      if (tag) {
        tag.addEventListener('click', () => {
          document.querySelector('input.form-control').focus();
        });
      }
    }, 200);
  },
  methods: {
    loadGroupUser(options) {
      return this.$emit('groupUserChange', JSON.parse(JSON.stringify(options)));
    },
    screenReader() {
      this.loadGroupUser(this.screenGroupUsers);
    }
  }
};
</script>
